<template>
  <div>
    <h1 class="common__main-title">Edit Schedule</h1>
    <div class="common__sub-title">
      <span>Edit</span>
    </div>
    <TutorInfo :tutor="tutor"/>
    <div class="content-wrapper">
      <ValidationObserver ref="observer">
        <InputForm :scheduleId="$route.params.scheduleId" v-model="schedule" />
      </ValidationObserver>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'TimesheetDetail',
            params: { tutorId: $route.params.tutorId },
          }"
        >
            Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="formValidate"
        >
          Confirm
        </b-button>
      </div>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { ValidationObserver } from 'vee-validate'
import { Schedule } from '@/store/schedules/types'
import { Tutor } from '@/store/tutors/types'
import TutorInfo from '@/components/parts/TutorInfo.vue'
import InputForm from '@/components/parts/schedules/InputForm.vue'
import Loading from '@/components/parts/modal/Loading.vue'

export default Vue.extend({
  components: {
    ValidationObserver,
    TutorInfo,
    InputForm,
    Loading,
  },

  data: (): {
    schedule: Schedule|null
    isLoading: boolean
  } => ({
    schedule: null,
    isLoading: false,
  }),

  computed: {
    tutor(): Tutor {
      const schedule: Schedule = this.$store.getters.getScheduleById(this.$route.params.scheduleId)
      return schedule && schedule.tutor
    },
  },

  created() {
    this.isLoading = true
    this.$store.dispatch('fetchScheduleById', { id: this.$route.params.scheduleId })
      .finally(() => { this.isLoading = false })
  },

  methods: {
    /* inputformのバリデーションを実行(veeValidate) */
    formValidate() {
      (this.$refs.observer as any).validate()
        .then((result: any) => {
          if (result !== true) {
            // 問題があれば何もしない
            return
          }

          this.$router.push({
            name: 'EditScheduleConfirm',
            params: { editingSchedule: JSON.stringify(this.schedule) },
          })
        });
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}

.student {
  margin-bottom:10px;
  align-items: center;
  display: flex;
}

.student-name {
  margin-right:20px;
}

</style>
